import all from './all';
import store from './store';
import items from './items';
import destroy from './destroy';
import subscribeSwitch from './subscribeSwitch';
import subscribeSwitchAll from './subscribeSwitchAll';

export default {
  all,
  store,
  items,
  destroy,
  subscribeSwitch,
  subscribeSwitchAll,
};



// WEBPACK FOOTER //
// ./src/app/services/subscriber/index.js